import { apiClient } from '@/core/api/client';

export type ClaimGuestCarePlanResult = {
  claimed: boolean;
};

/**
 * Claim a navigator session + care plan that were built while anonymous, re-owning
 * them to the now-authenticated user (POST /navigator/claim-guest-plan). The backend
 * only claims rows still owned by no one (owner_user_id IS NULL), so this is safe and
 * idempotent. Called from AuthCallback right after signup completes.
 */
export async function claimGuestCarePlan(
  sessionId: string,
): Promise<ClaimGuestCarePlanResult> {
  const res = await apiClient.post<ClaimGuestCarePlanResult>(
    '/navigator/claim-guest-plan',
    { sessionId },
    // Runs right after signup when the fresh token can momentarily be stale; a
    // transient 401 must not bounce the user to /login mid-flow. Caller handles it.
    { skipAuthRedirect: true },
  );
  return res.data;
}
